import { render } from "./TechnicalSupportService.vue?vue&type=template&id=446dc94e&scoped=true"
import script from "./TechnicalSupportService.vue?vue&type=script&lang=js"
export * from "./TechnicalSupportService.vue?vue&type=script&lang=js"

import "./TechnicalSupportService.vue?vue&type=style&index=0&id=446dc94e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-446dc94e"]])

export default __exports__